<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card p-3 border-radius-xl bg-white">
          <div class="card-header">
            <h5 class="font-weight-bolder mb-0mb-0">{{ $t("Listini QR")}}</h5>
            <div class="button-row d-flex">
              <router-link :to="{name:'Listino', params:{id: 0}}" class="ms-auto">
                <argon-button
                    type="button"
                    color="dark"
                    variant="gradient"
                >{{$t('Nuovo')}}</argon-button>
              </router-link>
            </div>
          </div>
          <div class="card-body">
            <listini-data-table :key="listiniKey" :listini="listini"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListiniDataTable from "@/parts/DataTables/ListiniDataTable.vue";
import ArgonButton from "@/components/ArgonButton.vue";

export default {
  name: "Listini",
  components: {ArgonButton, ListiniDataTable},
  data() {
    return {
      listini: [],
      listiniKey: Math.random()
    };
  },
  mounted() {
    this.apiClient.getListini().then(response => {
      if(response.data){
        this.listini = response.data;
        this.listiniKey = Math.random();
      }
    });
  },
};
</script>
